import { PROMO } from 'constants/EntryPoint';
import { NO_AUTH_VIEW } from 'constants/ServerConstants';

import AcceptInvitePage from 'pages-no-auth/AcceptInvitePage';
import ApplePayPage from 'pages-no-auth/ApplePayPage';
import BonusPage from 'pages-no-auth/BonusPage';
import BusinessAccountPage from 'pages-no-auth/business/account/BusinessAccountPage';
import BusinessEnterpriseLandingPageV2 from 'pages-no-auth/business/enterprise/EnterprisePageV2';
import AboutUsPage from 'pages-no-auth/company/AboutUsPage';
import CareerPage from 'pages-no-auth/company/career/CareerPage';
import CulturePage from 'pages-no-auth/company/career/CulturePage';
import LeadershipTeamPage from 'pages-no-auth/company/LeadershipTeamPage';
import CookiesPage from 'pages-no-auth/CookiesPage';
import HelpArticlePage from 'pages-no-auth/help/HelpArticlePage';
import SupportedCountriesPage from 'pages-no-auth/help/SupportedCountriesPage';
import ZendeskHelpArticlePage from 'pages-no-auth/help/ZendeskHelpArticlePage';
import ZendeskHelpCategoryPage from 'pages-no-auth/help/ZendeskHelpCategoryPage';
import ZendeskHelpPage from 'pages-no-auth/help/ZendeskHelpPage';
import ZendeskHelpSectionPage from 'pages-no-auth/help/ZendeskHelpSectionPage';
import LibreNoAuthChequePage from 'pages-no-auth/info/LibreNoAuthChequePage';
import LicensePage from 'pages-no-auth/LicensePage';
import OldBrowsersPage from 'pages-no-auth/OldBrowsersPage';
import PartnersPage from 'pages-no-auth/PartnersPage';
import PrivacyPolicyPage from 'pages-no-auth/PrivacyPolicyPage';
import ProhibitedActivitiesPage from 'pages-no-auth/ProhibitedActivitiesPage';
import RulesPage from 'pages-no-auth/RulesPage';
import SamsungPayPage from 'pages-no-auth/SamsungPayPage';
import SelectRegionPage from 'pages-no-auth/SelectRegionPage';
import StatusNoAuthPage from 'pages-no-auth/StatusNoAuthPage';
import UvnPage from 'pages-no-auth/UvnPage';
import WhiteScreenMobileAppPage from 'pages-no-auth/WhiteScreenMobileAppPage';

import { FOOTER_TYPE_BUSINESS, FOOTER_TYPE_DEFAULT, FOOTER_TYPE_SIMPLE, LANG_COUNTRY } from './routeConstant';
import ZendeskHelpMobileArticlePage from '../pages-no-auth/help-mobile/ZendeskHelpMobileArticlePage';
import ZendeskHelpMobileCategoryPage from '../pages-no-auth/help-mobile/ZendeskHelpMobileCategoryPage';
import ZendeskHelpMobilePage from '../pages-no-auth/help-mobile/ZendeskHelpMobilePage';
import ZendeskHelpMobileSectionPage from '../pages-no-auth/help-mobile/ZendeskHelpMobileSectionPage';

const noAuth = [
    {
        path: [
            `/${LANG_COUNTRY}/supported_countries`,
            `/${LANG_COUNTRY}/supported-countries`,
            `/${LANG_COUNTRY}/help/info/supported_countries`,
            `/${LANG_COUNTRY}/help/info/supported-countries`,
        ],
        exact: true,
        component: SupportedCountriesPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/supported-country',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/auth/cookie-policy', '/cookie-policy', `/${LANG_COUNTRY}/cookie-policy`],
        component: CookiesPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/cookies-v2',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/prohibited-activities', `/${LANG_COUNTRY}/prohibited-activities`],
        component: ProhibitedActivitiesPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/prohibited-activities-page',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/browsers`, '/browsers'],
        component: OldBrowsersPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/browser-page?populate=Browsers.Icon',
            strapiApiUseCache: true,
            strapiApiExtraName: 'browsers_page',
            isIncludeIeCss: true,
        },
    },
    {
        path: [
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/section/:sectionId/article/:articleId`,
            '/help-mobile/category/:categoryId/section/:sectionId/article/:articleId',
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/section/:sectionId/article/:articleId/showChat`,
            '/help-mobile/category/:categoryId/section/:sectionId/article/:articleId/showChat',
        ],
        exact: true,
        component: ZendeskHelpMobileArticlePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: false,
            entryPoint: PROMO,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'article',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
            isHelpMobile: true,
        },
    },
    {
        path: [
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/section/:sectionId`,
            '/help-mobile/category/:categoryId/section/:sectionId',
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/section/:sectionId/showChat`,
            '/help-mobile/category/:categoryId/section/:sectionId/showChat',
        ],
        exact: true,
        component: ZendeskHelpMobileSectionPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: false,
            entryPoint: PROMO,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'section',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
            isHelpMobile: true,
        },
    },
    {
        path: [
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId`,
            '/help-mobile/category/:categoryId',
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/showChat`,
            '/help-mobile/category/:categoryId/showChat',
        ],
        exact: true,
        component: ZendeskHelpMobileCategoryPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: false,
            entryPoint: PROMO,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'category',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
            isHelpMobile: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help-mobile`, '/help-mobile', `/${LANG_COUNTRY}/help-mobile/showChat`, '/help-mobile/showChat'],
        exact: true,
        component: ZendeskHelpMobilePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: false,
            entryPoint: PROMO,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'main',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
            isHelpMobile: true,
        },
    },
    {
        path: [
            `/${LANG_COUNTRY}/help/category/:categoryId/section/:sectionId/article/:articleId`,
            '/help/category/:categoryId/section/:sectionId/article/:articleId',
        ],
        exact: true,
        component: ZendeskHelpArticlePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: false,
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'article',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help/category/:categoryId/section/:sectionId`, '/help/category/:categoryId/section/:sectionId'],
        exact: true,
        component: ZendeskHelpSectionPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: false,
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'section',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help/category/:categoryId`, '/help/category/:categoryId'],
        exact: true,
        component: ZendeskHelpCategoryPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: false,
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'category',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help`, '/help'],
        exact: true,
        component: ZendeskHelpPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: false,
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'main',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help/:category/:article`],
        component: HelpArticlePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        stateOptions: {
            entryPoint: PROMO,
        },
    },
    {
        path: ['/rules', `/${LANG_COUNTRY}/rules`],
        component: RulesPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v1/terms-conditions',
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            strapiApiUseCache: true,
        },
    },
    {
        path: ['/select-region', `/${LANG_COUNTRY}/select-region`],
        component: SelectRegionPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v1/select-region',
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/partners', `/${LANG_COUNTRY}/partners`],
        component: PartnersPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v2/partners',
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_SIMPLE,
            menuSection: 'company',
            strapiApiUseCache: true,
        },
        renderOptions: {
            isHR: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/apple-pay`],
        component: ApplePayPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/apple-pay-v2',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isApplePay: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/samsung-pay`],
        component: SamsungPayPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/samsung-pay',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isGlobalAccountHelp: true,
        },
    },
    {
        path: ['/web/pay/accepted'],
        component: WhiteScreenMobileAppPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: true,
        stateOptions: {},
    },
    {
        path: ['/success', '/fail', '/waiting', '/close'],
        component: StatusNoAuthPage,
        view: NO_AUTH_VIEW,
    },
    {
        path: ['/license/us', `/${LANG_COUNTRY}/license/us`],
        component: LicensePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/license-us',
            pageName: 'other',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/culture', `/${LANG_COUNTRY}/culture`],
        exact: true,
        component: CulturePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v2/culture',
            entryPoint: PROMO,
            menuSection: 'company',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_SIMPLE,
        },
        renderOptions: {
            isHR: true,
        },
    },
    {
        path: ['/business/enterprise', `/${LANG_COUNTRY}/business/enterprise`],
        component: BusinessEnterpriseLandingPageV2,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/enterprise',
            pageName: 'enterprise',
            menuSection: 'business',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_BUSINESS,
        },
        renderOptions: {
            isBusinessConnect: true,
        },
    },
    {
        path: ['/leadership-team', `/${LANG_COUNTRY}/leadership-team`],
        component: LeadershipTeamPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/leadership-v2',
            pageName: 'other',
            menuSection: 'company',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isHR: true,
        },
    },
    {
        path: ['/about-us', `/${LANG_COUNTRY}/about-us`],
        component: AboutUsPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_SIMPLE,
            menuSection: 'company',
            pageName: 'other',
            strapiApi: '/api/v2/about-us',
            strapiApiUseCache: true,
        },
    },
    {
        path: ['/careers', `/${LANG_COUNTRY}/careers`],
        component: CareerPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/career',
            pageName: 'other',
            menuSection: 'company',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_SIMPLE,
        },
    },
    {
        path: ['/business/instant-account-payout', `/${LANG_COUNTRY}/business/instant-account-payout`],
        component: BusinessAccountPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/account-to-account',
            pageName: 'enterprise',
            menuSection: 'business',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_BUSINESS,
        },
        renderOptions: {
            isBusinessConnect: true,
        },
    },
    {
        path: ['/libre/:requestKey'],
        component: LibreNoAuthChequePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/libre-page/{:requestKey}',
            footerType: FOOTER_TYPE_DEFAULT,
            noIndex: true,
        },
        renderOptions: {
            isLibre: true,
        },
    },
    {
        path: ['/es-us/uvn'],
        component: UvnPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/uvn-page',
            pageName: 'landing',
            menuSection: 'personal',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
            noIndex: true,
        },
        renderOptions: {
            hideFooterCountryLang: true,
        },
    },
    {
        path: ['/bonus', `/${LANG_COUNTRY}/bonus`],
        component: BonusPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/bonus-v2',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/referral/:code', '/dl/referral/:code', `/${LANG_COUNTRY}/referral/:code`],
        component: AcceptInvitePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/accept-invite-page',
            pageName: 'landing',
            menuSection: 'personal',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
            noIndex: true,
        },
    },
    {
        path: ['/rules/privacy-policy', `/${LANG_COUNTRY}/rules/privacy-policy`, '/privacy-policy', `/${LANG_COUNTRY}/privacy-policy`],
        component: PrivacyPolicyPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/privacy-policy-page',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
];

export default noAuth;
